import {ajax, baseURL, download, serviceDownload, ajax2} from './ops'
import {excelAjax} from './excel'
import {serviceAjax} from './service'
import {annualsurvey} from './annualsurvey'
import {appdepAjax, appdepFileAjax} from './appdep'

const staticDownload = function (url, filename) {
  const link = document.createElement('a')
  link.style.display = 'none'
  link.download = filename
  link.href = url
  document.body.appendChild(link)
  link.click()
  link.remove()
}
/*
* 1、可以下载PDF，而不是直接浏览器打开PDF
* 2、可以重命名文件名
* */
const downloadFile = function (url, filename) {
  fetch(url, {
    headers: new Headers({
      Origin: location.origin
    }),
    mode: 'cors'
  })
    .then(res => {
      return res.blob()
    })
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      staticDownload(blobUrl, filename)
      window.URL.revokeObjectURL(blobUrl)
    })
}

export {
  baseURL,
  ajax,
  download,
  staticDownload,
  downloadFile,
  excelAjax,
  serviceAjax,
  annualsurvey,
  serviceDownload,
  appdepAjax,
  appdepFileAjax,
  ajax2
}



// WEBPACK FOOTER //
// ./src/libs/ajax/index.js